import requests from "./httpService";

const CountryServices = {

  addCountry: async (body) => {
    return requests.post("/country/add", body);
  },
  getAllCountry: async (body) => {
    return requests.get("/country/", body);
  },
  getCountryById: async (id, body) => {
    return requests.get(`/country/${id}`, body);
  },

  updateCountry: async (id, body) => {
    return requests.put(`/country/update/${id}`, body);
  },

  deleteCountry: async (id) => {
    return requests.put(`/country/delete/${id}`);
  },
 
};

export default CountryServices;
